// PeruseLab adamantane brand mark. Vendored from https://cdn.peruselab.com/images/Adamentane.svg
// (© peruselab.com) so it works offline / under CSP / in tests without a runtime CDN fetch;
// re-copy from that URL when the artwork changes. White strokes with a #1976d2 accent polyline —
// it sits on the primary-blue top bar, where the accent line reads as negative space.
export function BrandLogo({ className }: { readonly className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="3 9 204 270"
      aria-hidden="true"
      focusable="false"
    >
      <g fill="none" stroke="#fff" strokeWidth={14} strokeLinejoin="round">
        <polyline points="45,215 72,140 133,94" />
        <polyline points="135,140 73,94" stroke="#1976d2" strokeWidth={23} />
        <polyline points="159,215 196,142 133,94 103,16.5 73,94 11,142 45,215 103,262 159,215 135,140 73,94" />
      </g>
    </svg>
  );
}
